// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2znsn","ranges":"BmiRanges_ranges__1_V1e"};